var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58724 6.23594L9.18524 1.00394C9.26086 0.852527 9.37718 0.725173 9.52113 0.636161C9.66508 0.547149 9.83099 0.5 10.0002 0.5C10.1695 0.5 10.3354 0.547149 10.4793 0.636161C10.6233 0.725173 10.7396 0.852527 10.8152 1.00394L13.4132 6.23594L19.2212 7.07994C19.3888 7.10317 19.5464 7.17303 19.6761 7.28155C19.8058 7.39007 19.9024 7.53288 19.9549 7.69367C20.0073 7.85446 20.0135 8.02676 19.9727 8.19089C19.932 8.35503 19.8458 8.5044 19.7242 8.62194L15.5222 12.6919L16.5142 18.4419C16.6412 19.1799 15.8612 19.7419 15.1942 19.3939L10.0002 16.6779L4.80524 19.3939C4.13924 19.7429 3.35924 19.1799 3.48624 18.4409L4.47824 12.6909L0.276238 8.62094C0.155224 8.50332 0.0696361 8.3541 0.0292021 8.19026C-0.0112319 8.02641 -0.00488989 7.85451 0.0475071 7.69409C0.0999042 7.53367 0.196255 7.39116 0.325607 7.28277C0.454959 7.17439 0.612124 7.10446 0.779238 7.08094L6.58724 6.23594Z",
    fill: "#F6B51C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMarkFilled);
export default __webpack_public_path__ + "static/media/BookMarkFilled.157886f6a6fdb81dc60ef8555636a95b.svg";
export { ForwardRef as ReactComponent };